import {Cart} from "./Cart";
import {Delivery} from "./Delivery";
import {Display} from "./Display";
import {Form} from "./Form";
import {Load} from "./Load";
import {Payment} from "./Payment";
import {Product} from "./Product";
import {Shop} from "./Shop";
import {Modal} from "./Modal";

// noinspection JSUnresolvedVariable,JSUnresolvedFunction
export class Basic
{
    static init()
    {
        Basic.base = '/';
        Basic.lang = document.documentElement.lang;
        Basic.resizeTimer = 0;
        Basic.scrollTimer = 0;
        Basic.ise = (document.body.dataset.ise === 'on');
        Basic.navHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--nav-height'));
        Basic.cart = new Cart();
        Basic.delivery = new Delivery();
    }

    static add_changeEvent()
    {
        document.body.addEventListener('change',e =>
        {
            let el = e.target;

            if(el.closest('.w__js-change'))
            {
                el = el.closest('.w__js-change');
            }

            if(el.classList.contains('w__js-change') &&
              !el.classList.contains('inactive') &&
               el.dataset.f)
            {
                switch(el.dataset.f)
                {
                    case 'add-file':
                        Form.add_file(el);
                        break;

                    case 'cart-update-remark':
                        Basic.cart.update_remark(el.value.trim());
                        break;

                    case 'check-cart-validity':
                        Basic.cart.check_validity(true);
                        break;

                    case 'check-post-code':
                        Form.check_post_code(el)
                        break;

                    case 'check-product-validity':
                        // do nothing
                        break;

                    case 'filter':
                        const myShop = new Shop();
                        myShop.refresh_products();
                        break;

                    case 'toggle-address':
                        Basic.delivery.toggle_address(el);
                        break;

                    case 'toggle-delivery':
                        Basic.delivery.toggle_deliveryType(el);
                        break;

                    case 'toggle-option':
                        if(el.checked)
                        {
                            if(el.classList.contains('w__input--radio'))
                            {
                                const oldEl = el.closest('.w__product--section')
                                                .querySelector('.w__product--option.active');
                                if(oldEl)
                                {
                                    oldEl.classList.remove('active');
                                }

                                Product.toggle_image(el);
                            }
                            el.closest('.w__product--option').classList.add('active');
                        }
                        else
                        {
                            el.closest('.w__product--option').classList.remove('active');
                        }
                        Product.update_sum();
                        break;

                    case 'toggle-payment':
                        const payment = new Payment(el.value);
                        payment.process('set-payment');
                        break;

                    case 'update-cart':
                        Basic.cart.update_prices(el);
                        break;

                    case 'update-delivery-date':
                        Basic.delivery.validate_deliveryDate(true)
                        break;

                    case 'update-pickup-datetime':
                        Basic.delivery.validate_pickupDateTime(true)
                        break;

                    case 'upload-image':
                        Basic.cart.process_image(el);
                        break;

                    default:
                        console.log('Missing case change: ' + el.dataset.f);
                }
            }
        });
    }

    static add_clickEvent()
    {
        document.body.addEventListener('click',e =>
        {
            const page = Product.get_productPage();
            let el = e.target;

            if(el.classList.contains('ise') || el.closest('.ise'))
            {
                return false;
            }
            else if(el.closest('.w__js-button'))
            {
                el = el.closest('.w__js-button');
            }

            if(el.classList.contains('w__js-button') &&
              !el.classList.contains('inactive') &&
              el.dataset.f)
            {
                switch(el.dataset.f)
                {
                    case 'add-to-cart':
                        if(page && Product.check_validity(page))
                        {
                            Basic.cart.add_product(page);
                        }
                        break;

                    case 'cart-change':
                        Basic.cart.edit_cart(parseInt(el.dataset.cartKey));
                        break;

                    case 'cart-delete':
                        Basic.cart.delete_item(el);
                        break;

                    case 'cart-delete-image':
                        Basic.cart.delete_image(parseInt(el.dataset.cartKey));
                        break;

                    case 'cart-extra-delete':
                        Basic.cart.delete_extra(el);
                        break;

                    case 'cart-update-item':
                        if(page && Product.check_validity(page))
                        {
                            Basic.cart.add_product(page, parseInt(el.dataset.cartKey));
                        }
                        break;

                    case 'delivery':
                        Basic.delivery.process(el.dataset.action);
                        break;

                    case 'display-cart':
                        Basic.cart.display_cart(true);
                        break;

                    case 'filter':
                        Shop.toggle_filter(el);
                        break;

                    case 'filter-reset':
                        Shop.reset_filters();
                        break;

                    case 'finalize-order':
                        if(['cash', 'on_account'].includes(el.dataset.action))
                        {
                            const payment = new Payment(el.dataset.action);
                            payment.process(el.dataset.f);
                        }
                        break;

                    case 'form-toggle-condition':
                        Form.toggle_condition(el);
                        break;

                    case 'payment':
                        const payment = new Payment();
                        payment.process(el.dataset.action, el)
                        break;

                    case 'remove-file':
                        Form.remove_file(el);
                        break;

                    case 'search-reset':
                        Shop.reset_search(el);
                        break;

                    case 'toggle-menu':
                        e.preventDefault();
                        if(document.body.classList.contains('mod--menu-active'))
                        {
                            document.body.classList.remove('mod--menu-active');
                            document.documentElement.scrollTo(0, parseInt(sessionStorage.getItem('scrollY')));
                            sessionStorage.removeItem('scrollY');
                        }
                        else
                        {
                            sessionStorage.setItem('scrollY', window.scrollY.toString());
                            document.body.classList.add('mod--menu-active');
                        }
                        break;

                    case 'toggle-pw':
                        e.preventDefault();
                        const pwField = el.closest('.w__input--container').querySelector('.w__input--text');
                        pwField.type = (pwField.type === 'password') ? 'text' : 'password';
                        break;

                    case 'user-edit':
                        Load.post(Basic.base + 'user',{
                            f: 'user',
                            action: 'edit'
                        }).then(r => {
                            el.closest('.w__module.mod--user').innerHTML = r['html'];
                            Basic.do_afterLoad();
                        }).catch(error => {
                            new Modal(error['html'],true);
                        });
                        break;

                    case 'user-send-confirmation':
                        const modal = new Modal('E-Mail wird gesendet.');
                        Load.post(Basic.base + 'user',{
                            f: 'user',
                            action: 'send-confirmation-email',
                            userId: el.dataset.userId ? parseInt(el.dataset.userId) : 0
                        }).then(r => {
                            modal.remove();
                            Form.display_confirmation(r);
                        }).catch(error => {
                            modal.remove();
                            new Modal(error['html'],true);
                        });
                        break;

                    case 'user-toggle-order':
                        const order = document.getElementById(el.dataset.id);
                        if(order)
                        {
                            order.classList.toggle('active');
                            el.classList.toggle('active');
                        }
                        break;

                    default:
                        console.log('Missing case click: ' + el.dataset.f);
                }
            }
            else if(el.classList.contains('inactive'))
            {
                e.preventDefault();
            }
        });
    }

    static add_keyupEvent()
    {
        document.body.addEventListener('keyup',e =>
        {
            let el = e.target;

            if(el.classList.contains('w__js-keyup') &&
               el.dataset.f)
            {
                switch(el.dataset.f)
                {
                    case 'check-cart-validity':
                        Basic.cart.check_validity(false);
                        break;

                    case 'check-post-code':
                        Form.check_post_code(el)
                        break;

                    case 'check-product-validity':
                        Product.check_validity();
                        break;

                    case 'update-cart':
                        Basic.cart.update_prices(el);
                        break;

                    default:
                        console.log('Missing case keyup: ' + el.dataset.f);
                }
            }
        });
    }

    static do_afterLoad()
    {
        const filterPane = document.body.querySelector('.w__shop--filters');
        if(filterPane && sessionStorage.getItem('shop-filters'))
        {
            Shop.restore_filters(filterPane);
            Shop.toggle_filterPane();
        }

        // calculate product price
        Product.update_sum();

        // check cart validity
        Basic.cart.check_validity();

        // activate forms
        let forms = document.body.querySelectorAll('.w__form:not(.active)');
        for(let i=0; i<forms.length; i++)
        {
            new Form(forms[i]);
        }

        // update cart icon
        Basic.cart.update_cartIcon();

        // insert PayPal
        Payment.insert_payPal();
    }

    static process_resize()
    {
        Display.analyze();
    }

    static process_scroll()
    {
        if(document.body.classList.contains('mod--logo'))
        {
            const bigLogo = document.body.querySelector('.w__logo--image');
            if(bigLogo.getBoundingClientRect()['top'] + bigLogo.getBoundingClientRect()['height'] - Basic.navHeight > 0)
            {
                document.body.classList.remove('mod--logo-on-scroll');
            }
            else
            {
                document.body.classList.add('mod--logo-on-scroll');
            }
        }
    }

    static return_price(sum)
    {
        return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(sum);
    }
}

